module.exports = __webpack_public_path__ + "a7696fa6b4a865a9e6df062dbc3409d9.woff";